<template>
  <div id="app">
    <contentTop></contentTop>
    <router-view />
    <contentBut></contentBut>
  </div>
</template>

<script>
import contentTop from "./components/contentTop.vue";
import contentBut from "./components/contentBut.vue";
export default {
  components: {
    contentTop,
    contentBut,
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: #f5f5f5;
  
}
body {
  margin: 0;
  padding: 0;
}
nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.box {
  margin: 0;
  padding: 0;
  width: 100%;
}
ul {
  list-style-type: none; /* 移除列表的标准列表项目符号 */
  padding-left: 0; /* 将左侧的填充设置为0，移除默认的缩进 */
}
ul li {
  list-style: none; /* 确保列表项目也没有列表项目符号 */
  display: inline-block;
}
a {
  text-decoration: none;
  color: #000;
}
.clearfix::after {
  content: "";
  display: table;
  clear: both;
}

.BoxContent {
  width: 70rem;
  position: relative;
  margin-bottom: 2rem;
}
.BoxContentName {
  text-align: center;
  font-size: 2.8rem;
  font-weight: 700;
  color: #211714;
  margin: 2rem 0 1rem;
  padding-top: 3rem;
  z-index: 2;
}
.BoxContentNames {
  font-size: 7.5rem;
  color: #d3d3d3;
  opacity: 0.24;
  text-align: center;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
}
@media (max-width: 768px) {
  .BoxContentName {
    font-size: 2.3rem;
    padding-top: 2rem;
  }
  .BoxContentNames {
    font-size: 5.5rem;
  }
}
@media (max-width: 480px) {
  .BoxContentName {
    font-size: 1.8rem;
    padding-top: 1rem;
  }
  .BoxContentNames {
    font-size: 4.1rem;
  }
}
</style>
